"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Add CSS style to the page
 */
function appendStyle($, 
// Example: `.title { color: red; }`
css) {
    var styleElement = $("<style>" + css + "</style>");
    var head = $('head'); // Cheerio already makes sure head is present
    head.append(styleElement);
}
exports.default = appendStyle;
